import { styled, TableRow } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even) td': {
    backgroundColor: theme.palette.blue100.main,
  },
  '&:hover td': {
    backgroundColor: theme.palette.blue100.main,
  },
}));
